// src/features/chat/components/RecordCitationMarkdown.jsx

import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import PropTypes from 'prop-types';
import {
  linkRecordCitationsInMarkdown,
} from './recordCitationMarkdownUtils';

export { linkRecordCitationsInMarkdown };

export function RecordCitationMarkdown({ text, recordCitations }) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
      {linkRecordCitationsInMarkdown(text, recordCitations)}
    </ReactMarkdown>
  );
}

RecordCitationMarkdown.propTypes = {
  text: PropTypes.string,
  recordCitations: PropTypes.arrayOf(
    PropTypes.shape({
      recordId: PropTypes.string.isRequired,
      recordUrl: PropTypes.string,
      title: PropTypes.string,
    })
  ),
};

RecordCitationMarkdown.defaultProps = {
  text: '',
  recordCitations: [],
};

export default RecordCitationMarkdown;
